export const new_money_transition = `subscription new_money_transition{
    new_money_transition{
        transaction_code
        status
        from_account
        to_account
        amount
        currency
        transfer_date
        fulfillment_date
    }
}`;
